import { types } from "../Actions/types";
// import { cloneDeep, merge } from "lodash";


const initialState = {
    totalWorkoutReport: {
        workouts: {
            dates: [],
            recordcounts: []
        },
        reps: {
            dates: [],
            recordcounts: []
        },
        duration: {
            dates: [],
            recordcounts: []
        },
        caloriesBurnt: {
            dates: [],
            recordcounts: []
        },
        timeUnderTension: {
            dates: [],
            recordcounts: []
        },
        totalWeightLifted: {
            dates: [],
            recordcounts: []
        },
        avgWorkoutDuration: {
            dates: [],
            recordcounts: []
        }
    },
    strengthAssessmentReport: { dates: [], recordcounts: [] },
    userGoalCountReport: {
        getStronger: {
            dates: [],
            recordcounts: []
        },
        getLeaner: {
            dates: [],
            recordcounts: []
        }
    },
    workoutCompletedReport: {
        count: {
            dates: [],
            recordcounts: []
        },
        duration: {
            dates: [],
            recordcounts: []
        }
    },
    exerciseWiseStrengthAssessmentReport: { dates: [], recordcounts: [] },
    exerciseCategoryWiseWorkoutCompletedReport: { dates: [], recordcounts: [] },
    totalWeightsLiftedReport: { dates: [], recordcounts: [] },
    workoutSessionSplitMinutes: { dates: [], recordcounts: [] },
    // exerciseWiseStrengthAssessment:{dates:[],recordcounts:[]}
    totalWorkoutsCompletedHourly: {
        workouts: {
        dates: [],
        recordcounts: []
    }
},

userQuickTrainWorkouts: {
    dates: [],
    recordcounts: []
}

};

const userReportReducer = (state = initialState, action) => {
    const { type, payload } = action;

    switch (type) {
        case types.USER_REPORT_TOTAL_WORKOUT:
            return {
                ...state,
                totalWorkoutReport: payload.data,
            };


        case types.USER_REPORT_STRENGTH_ASSESSMENT:
            return {
                ...state,
                strengthAssessmentReport: payload.data,
            };

        case types.USER_REPORT_GOAL_COUNT:
            return {
                ...state,
                userGoalCountReport: payload.data,
            };
        case types.USER_REPORT_WORKOUT_COMPLETED:
            return {
                ...state,
                workoutCompletedReport: payload.data,
            };
        case types.USER_REPORT_EXERCISE_WISE_STRENGTH_ASSESSMENT:
            return {
                ...state,
                exerciseWiseStrengthAssessmentReport: payload.data,
            };

        case types.EXERCISE_CATEGORY_WISE_WORKOUT_COMPLETED_REPORT:
            return {
                ...state,
                exerciseCategoryWiseWorkoutCompletedReport: payload,
            };

        case types.TOTAL_WEIGHTS_LIFTED_REPORT:
            return {
                ...state,
                totalWeightsLiftedReport: payload,
            };


        case types.WORKOUT_SESSION_SPLIT_MINUTES:
            return {
                ...state,
                workoutSessionSplitMinutes: payload,
            };

        case types.USER_REPORT_TOTAL_WORKOUTS_BY_HOUR:
            return {
                ...state,
                totalWorkoutsCompletedHourly: payload,
            };

        case types.USER_QUICKTRAIN_WORKOUT:
            return {
                ...state,
               userQuickTrainWorkouts: payload.data.quickTrainWorkouts,
            };

        default:
            return state;
    }
};

export default userReportReducer;
